import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from "@angular/forms";
import { OversaleCalendarComponent } from "@root/router/component/calendar-picker/oversale-calendar/oversale-calendar.component";
import { PropertiesService } from "@root/router/properties/properties.service";
import { PropertyDetailService } from "@root/router/component/property/property-detail/property-detail.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { delay } from "rxjs";
import { omit, remove } from "lodash";
import { V4HousesModalSelectComponent } from "@root/router/component/v4/houses-modal-select/houses-modal-select.component";
import { HttpClient } from "@angular/common/http";
import { EditHouseComponent } from "@root/router/component/property/edit-house/edit-house.component";
import { Observable } from "rxjs";
import { NzMessageService } from "ng-zorro-antd/message";
import { Router } from "@angular/router";
import { ModalService } from "@root/router/index/modal.service";

interface DateItem {
  from: string;
  to: string;
  thirdparty_type?: number;
  dates?: string[];
}

@Component({
  selector: "room-type-detail-advanced",
  templateUrl: "./advanced.component.html",
  styleUrls: ["./advanced.component.scss"],
})
export class RTAdvancedComponent implements OnInit {
  @Input() id;
  @Input() detail;
  @Output() onUpdate = new EventEmitter();
  form: UntypedFormGroup = this.fb.group({
    is_allowed_overbooking: false,
    is_stop_managing_inventory: false,

    dates: [[]],
    date_list: [[]],
    thirdparty_dates: [[]],
    thirdparty_date_list: [[]],
  });
  oversaleDateItems: DateItem[] = []; // 展示在允许超售下面的日期，和form.dates不同，这里是处理过的展示数据，form.dates是原始数据

  listOfHouse = [];
  total = 0;
  page = 1;
  pageSize = 20;
  searchForm: UntypedFormGroup = this.fb.group({
    title: null,
    group_id: null,
    house_type_id: null,
    tags: null,
    operator_relation_id: null,
  });

  get houseIds() {
    return this.listOfHouse?.map((house) => house.id);
  }
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private t: TranslateService,
    private modal: NzModalService,
    private gModal: ModalService,
    private msg: NzMessageService,
    private propertySrv: PropertiesService,
    private service: PropertyDetailService,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.fetchSettingDetail();
    this.subscribeFormChange();
    this.fetchHouseList();
  }

  private fetchHouseList() {
    const values = this.searchForm.value;
    const params = {
      ...omit(values, "tags"),
      page: this.page,
      page_size: this.pageSize,
      house_type_id: this.id,
    };
    if (values.tags) {
      const [house_tag_type, house_tag_id] = values.tags;
      Object.assign(params, {
        house_tag_type,
        house_tag_id: JSON.stringify(house_tag_id),
      });
    }
    this.propertySrv.getHouseList(params).subscribe((rst) => {
      this.listOfHouse = rst?.data?.list;
      this.total = rst?.data?.total;
    });
  }

  private fetchSettingDetail() {
    this.service
      .getOverbookingDetails({
        link_id: this.id,
        link_type: "house_type",
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          const data = res.data || {};
          const {
            is_allowed_overbooking,
            is_stop_managing_inventory,
            date_list,
            dates,
            thirdparty_date_list,
            thirdparty_dates,
          } = data;

          this.oversaleDateItems = this.processOversaleDateItemsCompat(
            dates,
            date_list,
            thirdparty_dates,
            thirdparty_date_list,
          );

          this.form.patchValue(
            {
              ...data,
              is_allowed_overbooking: !!is_allowed_overbooking,
              is_stop_managing_inventory: !!is_stop_managing_inventory,
            },
            { emitEvent: false },
          );
        }
      });
  }

  private requestSaveSetting() {
    const value = this.form.value;
    const params = {
      link_id: this.id,
      link_type: "house_type",
      ...value,
      is_allowed_overbooking: value.is_allowed_overbooking & 1,
      is_stop_managing_inventory: value.is_stop_managing_inventory & 1,
    };
    this.service.setOverbooking(params).subscribe((rst) => {
      if (rst.error_code === 0) {
        this.fetchSettingDetail();
      }
    });
  }

  private requestUpdateHouseType(houseIds) {
    const params = {
      house_type_id: this.id,
      house_ids: houseIds,
    };
    this.http.post("/api/house_type/update", params).subscribe((rst) => {
      this.fetchHouseList();
      this.onUpdate.emit();
    });
  }

  private subscribeFormChange() {
    this.searchForm.valueChanges.subscribe((rst) => {
      this.fetchHouseList();
    });

    this.form.get("is_allowed_overbooking").valueChanges.subscribe((checked) => {
      if (checked) {
        if (!this.oversaleDateItems.length) {
          this.displayAddDatesModal();
        }
      } else {
        this.form.patchValue({
          dates: [],
          date_list: [],
        });
        this.requestSaveSetting();
      }
    });

    this.form
      .get("is_stop_managing_inventory")
      .valueChanges.pipe(delay(10))
      .subscribe((checked) => {
        console.log("is stop managing inventory change: ", checked);

        this.requestSaveSetting();
      });
  }

  private displayAddDatesModal() {
    const modal = this.modal.create({
      nzTitle: this.t.t("house.set_overbooking_date"),
      // nzContent: this.setOverSoldDate,
      nzContent: OversaleCalendarComponent,
      nzFooter: null,
      nzWidth: 750,
    });
    modal.afterClose.subscribe((rst) => {
      // modal返回为空的情况
      if (!rst) {
        // 当前超售列表为空的情况。不为空的情况无需处理
        if (this.oversaleDateItems.length === 0) {
          this.form.patchValue({ is_allowed_overbooking: false }, { emitEvent: false });
          // this.requestSaveSetting();
          return;
        }
      }

      const { dates } = rst;
      const _dates = this.form.get("dates").value;
      this.form.patchValue({ dates: [].concat(_dates, dates) });

      this.requestSaveSetting();
    });
  }

  private processOversaleDateItemsCompat(
    dates: string[],
    dateList: DateItem[],
    thirdpartyDates: { date: string; thirdparty_type: number }[],
    thirdpartyDateList: DateItem[],
  ) {
    const _dates: DateItem[] = dates.map((date) => ({ from: date, to: date }));
    const _thirdpartyDates: DateItem[] = thirdpartyDates.map((date) => ({
      from: date.date,
      to: date.date,
      thirdparty_type: date.thirdparty_type,
    }));

    return [..._dates, ...dateList, ..._thirdpartyDates, ...thirdpartyDateList];
  }

  onDeleteDateItem(item: DateItem, index: number): void {
    // 删除item
    this.oversaleDateItems.splice(index, 1);
    // 更新原始数据
    const deleteFormDateItem = (name, cb) => {
      const origin = this.form.value[name];
      remove(origin, cb);
      this.form.patchValue({ [name]: origin });
    };

    if (item.thirdparty_type === undefined) {
      console.log("Not channel date");

      if (item.from === item.to) {
        deleteFormDateItem("dates", (date) => date === item.from);
      } else {
        deleteFormDateItem("date_list", (date) => date.from === item.from && date.to === item.to);
      }
    } else {
      console.log("channel date");
      if (item.from === item.to) {
        deleteFormDateItem(
          "thirdparty_dates",
          (date) => date.date === item.from && date.thirdparty_type === item.thirdparty_type,
        );
      } else {
        deleteFormDateItem(
          "thirdparty_date_list",
          (date) => date.from === item.from && date.to === item.to && date.thirdparty_type === item.thirdparty_type,
        );
      }
    }
    // 全部删除后，需要将该选项置为false
    if (this.oversaleDateItems.length === 0) {
      this.form.patchValue({ is_allowed_overbooking: false }, { emitEvent: false });
    }

    this.requestSaveSetting();
  }

  onClickAddDateItem() {
    this.displayAddDatesModal();
  }

  onPageChange() {
    this.fetchHouseList();
  }

  onAddHouse() {
    // if (this.member.isEditionExceedQuantityLimit()) {
    //   this.member.editionCreateHouseLimitWarning();
    //   return;
    // }
    const createHouseModal = this.modal.create({
      nzTitle: this.t.t("house.create_house"),
      nzContent: V4HousesModalSelectComponent,
      nzFooter: null,
      nzWidth: 800,
      nzComponentParams: {
        params: { type: "exclude_all_house_type" },
      },
    });
    createHouseModal.afterClose.subscribe(({ data: rst }) => {
      if (rst) {
        const lists = this.detail?.house_list?.map((i) => i.house_id) || [];
        const added = rst.map((house) => house.value);
        // this.fetchHouseList();
        const ids = Array.from(new Set([...lists, ...added]));
        this.requestUpdateHouseType(ids);
        // this.initHouseList();

        // this.member.requestEditionInfo();
      }
    });
  }

  onViewCalendar(id) {
    this.gModal.displayPropertyCalendarDrawer(id);
  }

  onEditHouse(house) {
    const modal = this.modal.create({
      nzTitle: "Edit",
      nzContent: EditHouseComponent,
      nzWidth: 500,
      nzFooter: null,
      nzComponentParams: {
        type: "house",
        data: {
          id: house?.id,
          cover: house?.cover_picture,
          title: house?.house_title,
        },
      },
    });
    modal.afterClose.subscribe((rst) => {
      if (rst?.status === "ok") {
        this.fetchHouseList();
      }
    });
  }

  onRemoveHouse(house) {
    this.http
      .post("/api/house_type/remove_house", { house_id: house.id, house_type_id: this.id })
      .subscribe((rst: any) => {
        if (rst.error_code === 0) {
          this.msg.success(this.t.t("word.removed"));
          this.fetchHouseList();
          this.onUpdate.emit();
        }
      });
    // this.displayRemoveHouseWarning().subscribe(() => {
    // });
  }

  toResvPage() {
    this.router.navigate(["/app/reservations"], {
      queryParams: {
        house_ids: this.listOfHouse?.map((house) => house.id).join(","),
      },
    });
  }

  private displayRemoveHouseWarning() {
    return new Observable((observer) => {
      const modal = this.modal.confirm({
        nzTitle: "Are you sure you want to delete this property?",
        nzContent:
          "After a property is deleted, the reservations in the property will be retained but will not show up in the calendar unless you manually move the reservations to another property that exists.",
        nzOkText: "Yes",
        nzWidth: 500,
        nzOnOk: () => observer.next(null),
      });

      modal.afterClose.subscribe(() => observer.complete());
    });
  }
}
